
export interface ActivityLog {
  id: string;
  booking_id: string;
  event_type: string;
  actor_type: 'customer' | 'internal' | 'system';
  actor_id?: string;
  actor_name?: string;
  actor_email?: string;
  actor_phone?: string;
  description: string;
  metadata: Record<string, any>;
  created_at: string;
}

export const ACTIVITY_EVENT_TYPES = {
  // Booking lifecycle
  BOOKING_CREATED: 'booking_created',
  BOOKING_CANCELLED: 'booking_cancelled',
  STATUS_CHANGED: 'status_changed',
  
  // Quote management
  QUOTE_ADDED: 'quote_added',
  QUOTE_UPDATED: 'quote_updated',
  QUOTE_DELETED: 'quote_deleted',
  QUOTE_VIEWED: 'quote_viewed',
  QUOTE_ACCEPTED: 'quote_accepted',
  QUOTE_REJECTED: 'quote_rejected',
  
  // Payment
  PAYMENT_LINK_GENERATED: 'payment_link_generated',
  PAYMENT_LINK_VIEWED: 'payment_link_viewed',
  PAYMENT_RECEIVED: 'payment_received',
  PAYMENT_CONFIRMED: 'payment_confirmed',
  PAYMENT_FAILED: 'payment_failed',
  
  // Support
  SUPPORT_REQUEST_CREATED: 'support_request_created',
  SUPPORT_RESPONSE_SENT: 'support_response_sent',
  
  // Fulfillment
  ORDER_PROCESSING: 'order_processing',
  TRACKING_INFO_ADDED: 'tracking_info_added',
  TRACKING_UPDATED: 'tracking_updated',
  ORDER_SHIPPED: 'order_shipped',
  ORDER_DELIVERED: 'order_delivered',
  
  // Communication
  EMAIL_SENT: 'email_sent',
  SMS_SENT: 'sms_sent',
  SECURE_LINK_GENERATED: 'secure_link_generated',
  SECURE_LINK_ACCESSED: 'secure_link_accessed',
  
  // Feedback
  FEEDBACK_REQUESTED: 'feedback_requested',
  FEEDBACK_RECEIVED: 'feedback_received',
  
  // Admin actions
  ADMIN_NOTE_ADDED: 'admin_note_added',
  BOOKING_MODIFIED: 'booking_modified',
  CUSTOMER_CONTACTED: 'customer_contacted'
} as const;

export const ACTIVITY_DESCRIPTIONS: Record<string, string> = {
  [ACTIVITY_EVENT_TYPES.BOOKING_CREATED]: 'Booking created by customer',
  [ACTIVITY_EVENT_TYPES.BOOKING_CANCELLED]: 'Booking cancelled',
  [ACTIVITY_EVENT_TYPES.STATUS_CHANGED]: 'Booking status updated',
  
  [ACTIVITY_EVENT_TYPES.QUOTE_ADDED]: 'Quote added by staff',
  [ACTIVITY_EVENT_TYPES.QUOTE_UPDATED]: 'Quote updated by staff',
  [ACTIVITY_EVENT_TYPES.QUOTE_DELETED]: 'Quote deleted by staff',
  [ACTIVITY_EVENT_TYPES.QUOTE_VIEWED]: 'Quote viewed by customer',
  [ACTIVITY_EVENT_TYPES.QUOTE_ACCEPTED]: 'Quote accepted by customer',
  [ACTIVITY_EVENT_TYPES.QUOTE_REJECTED]: 'Quote rejected by customer',
  
  [ACTIVITY_EVENT_TYPES.PAYMENT_LINK_GENERATED]: 'Payment link generated',
  [ACTIVITY_EVENT_TYPES.PAYMENT_LINK_VIEWED]: 'Payment link viewed by customer',
  [ACTIVITY_EVENT_TYPES.PAYMENT_RECEIVED]: 'Payment received from customer',
  [ACTIVITY_EVENT_TYPES.PAYMENT_CONFIRMED]: 'Payment confirmed by staff',
  [ACTIVITY_EVENT_TYPES.PAYMENT_FAILED]: 'Payment failed',
  
  [ACTIVITY_EVENT_TYPES.SUPPORT_REQUEST_CREATED]: 'Support request created by customer',
  [ACTIVITY_EVENT_TYPES.SUPPORT_RESPONSE_SENT]: 'Support response sent by staff',
  
  [ACTIVITY_EVENT_TYPES.ORDER_PROCESSING]: 'Order processing started',
  [ACTIVITY_EVENT_TYPES.TRACKING_INFO_ADDED]: 'Tracking information added',
  [ACTIVITY_EVENT_TYPES.TRACKING_UPDATED]: 'Tracking information updated',
  [ACTIVITY_EVENT_TYPES.ORDER_SHIPPED]: 'Order shipped',
  [ACTIVITY_EVENT_TYPES.ORDER_DELIVERED]: 'Order delivered',
  
  [ACTIVITY_EVENT_TYPES.EMAIL_SENT]: 'Email notification sent',
  [ACTIVITY_EVENT_TYPES.SMS_SENT]: 'SMS notification sent',
  [ACTIVITY_EVENT_TYPES.SECURE_LINK_GENERATED]: 'Secure access link generated',
  [ACTIVITY_EVENT_TYPES.SECURE_LINK_ACCESSED]: 'Secure access link used',
  
  [ACTIVITY_EVENT_TYPES.FEEDBACK_REQUESTED]: 'Feedback requested from customer',
  [ACTIVITY_EVENT_TYPES.FEEDBACK_RECEIVED]: 'Feedback received from customer',
  
  [ACTIVITY_EVENT_TYPES.ADMIN_NOTE_ADDED]: 'Internal note added',
  [ACTIVITY_EVENT_TYPES.BOOKING_MODIFIED]: 'Booking details modified',
  [ACTIVITY_EVENT_TYPES.CUSTOMER_CONTACTED]: 'Customer contacted directly'
};

export const ACTOR_TYPE_LABELS: Record<string, string> = {
  customer: 'Customer',
  internal: 'Staff',
  system: 'System'
};
